import { Button, Col, Row, Table, Form, DatePicker } from "antd";
import skuService from "../../../services/sku";
import poService from "../../../services/po";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import saveAs from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import * as XLSX from "xlsx"; // Added import
const { Title } = Typography;

function PendingPOReport() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    form.setFieldsValue({
      endDate: dayjs(),
    });
    handleLoad();
  }, []);

  const handleLoad = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      const data = await poService.getPendingPOReport(
        values.endDate.toISOString()
      );
      setData(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadXlsx = () => {
    // Define headers matching AntD table
    const headers = [
      "PO ID",
      "Date",
      "Created By",
      "SKU Code",
      "Size",
      "Vendor",
      "Ordered Quantity",
      "Received Quantity",
      "Rejected Quantity",
      "Pending Quantity",
      "Age (Days)",
    ];

    // Transform data to match headers
    const transformedData = data.map((item) => ({
      "PO ID": item.poId,
      Date: dayjs(item.date).format("DD-MM-YYYY"),
      "Created By": item.createdBy,
      "SKU Code": item.skuCode,
      Size: item.size,
      Vendor: item.vendor,
      "Received Quantity": item.receivedQuantity,
      "Rejected Quantity": item.rejectedQuantity,
      "Pending Quantity": item.pendingQuantity,
      "Ordered Quantity": item.orderedQuantity,
      "Age (Days)": item.age,
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData, {
      header: headers,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PendingPOReport");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "PendingPOReport.xlsx");
  };
  const columns = [
    { title: "PO ID", dataIndex: "poId", key: "poId" },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => dayjs(date).format("DD-MM-YYYY"),
    },
    { title: "Created By", dataIndex: "createdBy", key: "createdBy" },
    { title: "SKU Code", dataIndex: "skuCode", key: "skuCode" },
    { title: "Size", dataIndex: "size", key: "size" },
    { title: "Vendor", dataIndex: "vendor", key: "vendor" },
    {
      title: "Ordered Quantity",
      dataIndex: "orderedQuantity",
      key: "orderedQuantity",
    },
    {
      title: "Received Quantity",
      dataIndex: "receivedQuantity",
      key: "receivedQuantity",
    },
    {
      title: "Rejected Quantity",
      dataIndex: "rejectedQuantity",
      key: "rejectedQuantity",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      key: "pendingQuantity",
    },
    { title: "Age (Days)", dataIndex: "age", key: "age" },
  ];
  return (
    <div>
      <Row justify="space-between">
        <Col>
          <Title level={3}>Pending PO Report</Title>
        </Col>
      </Row>
      <div className="mt-4">
        <Form form={form} layout="inline" className="mb-3">
          <Form.Item name="endDate" label="End Date" initialValue={dayjs()}>
            <DatePicker format="DD-MM-YYYY" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              onClick={() => handleLoad()}
              loading={loading}
            >
              Load Report
            </Button>
          </Form.Item>
          {data.length > 0 && (
            <Form.Item>
              <Button
                type="default"
                onClick={handleDownloadXlsx}
                icon={<DownloadOutlined />}
              >
                Download as XLSX
              </Button>
            </Form.Item>
          )}
        </Form>
        <Table dataSource={data} columns={columns} />
      </div>
    </div>
  );
}

export default PendingPOReport;
